import { AREA_OTTIMO, areaScores } from "./scoring";

// Qualitative crew report from the area scores (slot holder + other members' help); no numbers exposed.
const AREA_META = {
  command: { label: "Comando", female: false },
  combat: { label: "Combattimento", female: false },
  navigation: { label: "Navigazione", female: true },
  support: { label: "Supporto", female: false },
  specialist: { label: "Specialisti", female: false, plural: true },
};

const LEVELS = [
  { min: 90, m: "Eccezionale", f: "Eccezionale", p: "Eccezionali" },
  { min: AREA_OTTIMO, m: "Ottimo", f: "Ottima", p: "Ottimi" },
  { min: 70, m: "Buono", f: "Buona", p: "Buoni" },
  { min: 58, m: "Discreto", f: "Discreta", p: "Discreti" },
  { min: -Infinity, m: "Debole", f: "Debole", p: "Deboli" },
];

const formOf = (area) => {
  if (area.plural) return "p";
  return area.female ? "f" : "m";
};

export const analyzeCrew = (assignments) =>
  areaScores(assignments).map(({ key, value }) => {
    const meta = AREA_META[key];
    const level = LEVELS.findIndex((l) => value >= l.min);
    return { key, label: meta.label, verdict: LEVELS[level][formOf(meta)], tier: LEVELS.length - 1 - level };
  });
